export const modal = {
  namespaced: true,
  state: {
    isVisible: false
  },
  actions: {
    show({ commit }) {
      commit("show");
    },
    clear({ commit }) {
      commit("clear");
    }
  },
  mutations: {
    show(state) {
      state.isVisible = true;
    },
    clear(state) {
      state.isVisible = false;
    }
  }
};
